import { useState, useEffect } from "react";

/**
 * Current time, `null` until the browser has mounted.
 *
 * It must not be read during render: the server has no "now", so a value on the
 * first client render would break hydration of the server-rendered calendar
 * (and then shift the page once React corrects it). Consumers already treat
 * `null` as "hide the indicator".
 */
export function useCurrentTime() {
  const [currentTime, setCurrentTime] = useState<Date | null>(null);

  useEffect(() => {
    const tick = () => setCurrentTime(new Date());

    // Set the first value from a timer (never during render) and refresh it
    // every minute afterwards.
    const timeout = setTimeout(tick, 0);
    const interval = setInterval(tick, 60000);

    return () => {
      clearTimeout(timeout);
      clearInterval(interval);
    };
  }, []);

  return currentTime;
}
